






















































































import { Component, Vue, Prop } from "vue-property-decorator";

import fb from "@/firebaseConfig";
import moment, { now } from "moment";
import DeleteEvent from "@/components/DeleteEvent.vue";
import ImportResults from "@/components/ImportResults.vue";
import Importer from "@/components/Importer.vue";
import Vuetify from "vuetify";
import { Event, RaceCat } from "jsk-shared";
import * as apiEvents from "@/api/events";

@Component({
  components: {
    DeleteEvent,
    ImportResults,
    Importer
  }
})
export default class EditEvent extends Vue {
  eventRules = [(v: any) => !!v || "Is required"];
  hasValidatedResults = false;
  showDelete = false;
  triggerImport = false;
  importData = "";
  currentEventId = "new";
  dateMenu = false;
  stepStage = 1;
  eventDateClean = moment(now()).format("YYYY-MM-DD");
  event: Event = {
    name: "",
    racecat: RaceCat.SHORT3K,
    resultsurl: "",
    eventdate: new Date()
  };
  loading = false;

  raceCatList = Object.keys(RaceCat).map((key: any) => {
    return RaceCat[key];
  });

  @Prop()
  eventId!: any;

  mounted() {
    this.currentEventId = this.eventId;
    if (this.currentEventId != "new") {
      this.loading = true;

      apiEvents
        .getEvent(this.currentEventId)
        .then(e => {
          this.event = e;
          this.eventDateClean = moment(this.event.eventdate).format(
            "YYYY-MM-DD"
          );
        })
        .catch(apiEvents.handleError)
        .finally(() => {
          this.loading = false;
        });
    }
  }
  butSave() {
    if (!(this.$refs.form as Vue & { validate: () => boolean }).validate())
      return;

    this.loading = true;

    this.event.eventdate = new Date(this.eventDateClean);

    const sendEvent =
      this.currentEventId === "new"
        ? apiEvents.createEvent(this.event)
        : apiEvents.saveEvent(this.currentEventId, this.event);

    sendEvent
      .then(docId => {
        this.currentEventId = docId;
        this.stepStage = 2;
      })
      .catch(apiEvents.handleError)
      .finally(() => {
        this.loading = false;
      });
  }

  deleteEvent() {
    this.$router.push("/events");
  }

  importValiation(isValid: boolean, importDataIn: string) {
    this.importData = importDataIn;
    this.hasValidatedResults = isValid;
  }
}
